import React, { useState, useEffect} from "react";
import toast from "react-hot-toast";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import PageHeader from "@core/components/pageHeader";
import AddCalendarSetting from "views/pages/calendar/specialDays/AddCalendarSetting";
import CalendarSettingList from "views/pages/calendar/specialDays/CalendarSettingList";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import { useLocation } from "react-router-dom";
import Utility from "@core/helper/utility";
import { useSelector } from "react-redux";
import Loader from "@core/helper/Loader";

const CalendarSetting = () => {
  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [calendarList, setCalendarList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [updateData, setUpdateData] = useState(null);
  const [totalRecord, setTotalRecord] = useState("");
  const [permission, setPermission] = useState({});
  const [role, setRole] = useState("");
  const { userData } = useSelector((state) => state.auth);
  const location = useLocation();
  const handleDeleteModal = (id) => {
    if (id) {
      const payload = { id };
      APICall("delete", payload, EndPoints.deleteCalendarDate)
        .then((response) => {
          const { isError, message } = response.data;
          if (response.status === 200 && !isError) {
            toast.success(message);
            const filter = calendarList.filter((o) => o.id !== id);
            setCalendarList(filter);
            fetchCalendarSettingList();
          }
        })
        .catch((error) => {
          return error;
        });
    }
    setDeleteOpen(!deleteOpen);
  };

  const handleOpen = (type, id) => {
    setOpenModal(!openModal);
    setSearchText("");
    setType(type);
    if (id) {
      const findList = calendarList.find((o) => o.id === id);
      setUpdateData(findList);
    }
  };
  useEffect(() => {
    if (userData.data.user.role === "2") {
      const calender = Utility.getUserData({
        datastore:userData,
        activePath: location.pathname,
      });

      setPermission(calender[1]);
    } else {
      setPermission({});
    }

    setRole(userData.data.user.role);
  }, [location.pathname, userData]);
  
  useEffect(() => {
    fetchCalendarSettingList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, pageSize, pageNumber]);

  const fetchCalendarSettingList = () => {
    Loader.isLoading(true);

    const payload = {
      pageNo: pageNumber + 1,
      limit: pageSize,
      orderBy: "DESC",
      searchText: searchText,
    };
    APICall("post", payload, EndPoints.getCalendarDateList)
      .then((response) => {
        const { results, totalCount } = response.data.data;
        if (response.status === 200 && results) {
          setCalendarList(results);
          setTotalRecord(totalCount);
        } else {
          setCalendarList([]);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const submitCalendarSetting = () => {
    fetchCalendarSettingList();
  };

  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
           Special Days
          </Typography>
        }
      />
        {((permission.view && role === "2") || role === "1") && (
      <Grid item xs={12}>
        <CalendarSettingList
          handleDeleteModal={handleDeleteModal}
          deleteOpen={deleteOpen}
          handleOpen={handleOpen}
          calendarList={calendarList}
          pageSize={pageSize}
          setPageSize={setPageSize}
          searchText={searchText}
          setSearchText={setSearchText}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          totalRecord={totalRecord}
          permission={permission}
          role={role}
        />
         </Grid>
        )}
        {type !== undefined && (
          <AddCalendarSetting
            onSubmitCalendar={submitCalendarSetting}
            open={openModal}
            toggle={handleOpen}
            type={type}
            heading={
              type === "edit"
                ? "Update Special Days"
                : "Add Special Days"
            }
            updateData={updateData}
            permission={permission}
          />
        )}
      </Grid>
   
  );
};

export default CalendarSetting;
